import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react-hooks/exhaustive-deps */
import { BackdropLoader, Box, PageTabs, toast, ExpandedTooltip, Icon } from '@livable/saas-react-components';
import { Container, Paper, IconButton } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import BreadcrumbsBar from 'src/components/general/BreadcrumbsBar';
// import ReccuringChargesTable from 'src/components/allocations/ReccuringChargesTable';
import StatementsTable from 'src/components/statements/StatementsTable';
import FSEBillModal from 'src/components/resident/ResidentModal/MoveOutTab/FSEBillModal';
import ActivityLogTable from 'src/components/tenant/ActivityLogTable';
import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import { useStore } from 'src/stores';
import { useURLHandler } from 'src/utils/hooks';
import AllocationsTab from './AllocationsTab';
import DistributionSummary from './DistributionSummary';
import { ResidenciesTab } from './ResidenciesTab';
import { TopActionButtons } from './TopActionButtons';
import useStyles from './styles';
import { AppfolioBatchesTable } from './AppfolioBatchesTable';
// import ReportsTab from './ReportsTab';

export const ResidentsPage = observer(() => {
  const classes = useStyles();
  const history = useLocation();
  const navigate = useNavigate();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const params = new URLSearchParams(history.search);
  const fseModal = params.get('fseModal') === 'null' ? null : params.get('fseModal');
  const isEnrollModalOpen = params.get('enrollModal');
  const propertyId = params.get('id');
  const residencyIdPar = params.get('residencyId') === 'null' ? null : params.get('residencyId');
  const tabsNames = ['allocations', 'residencies', 'statements'];
  const isFinalStatementEstimationEnabled = store.account.featureFlagsStore.isFinalStatementEstimationEnabled;
  const _store$fse$FSEBillMod = store.fse.FSEBillModalData,
    residentName = _store$fse$FSEBillMod.residentName,
    residencyId = _store$fse$FSEBillMod.residencyId,
    unitName = _store$fse$FSEBillMod.unitName;
  const residency = store.residencies.residencies.get(residencyIdPar);
  const modalParams = {};
  if (fseModal) modalParams.fseModal = fseModal;
  if (residencyIdPar) modalParams.residencyId = residency;
  const _useURLHandler = _objectSpread({}, useURLHandler('residencies', tabsNames, _objectSpread(_objectSpread({}, modalParams), {}, {
      id: propertyId
    }))),
    handleSelectedTabChange = _useURLHandler.handleSelectedTabChange,
    selectedTab = _useURLHandler.selectedTab;
  const handleChange = (e, newValue) => {
    handleSelectedTabChange(newValue);
    store.residencies.saveActiveTab(newValue);
  };
  const breadcrumbArray = [{
    title: t('general.dashboard'),
    link: '/active_dashboard'
  }, {
    title: store.buildings.getBuilding.buildingAddress
  }];
  const tabs = [{
    value: 'residencies',
    label: t('general.residencies')
  }, {
    label: t('general.statements'),
    value: 'statements'
  }, {
    value: 'allocations',
    label: t('general.allocations')
  }
  // {
  //   value: 'charges',
  //   label: 'Charges and credits',
  // },
  // {
  //   value: 'reports',
  //   label: t('general.reports'),
  // },
  ];
  if (store.account.featureFlagsStore.getIsActivityLogsEnabled) {
    tabs.push({
      value: 'activity-log',
      label: t('general.activity_log')
    });
  }
  if (store.company.companyFeatureStore.isAppfolio) {
    tabs.push({
      value: 'appfolio-batches',
      label: t('general.appfolio_batches'),
      icon: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ExpandedTooltip, {
        type: "grey",
        title: t('general.activity_log_info'),
        placement: "top"
      }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
        state: "info",
        type: "info"
      })))),
      iconPosition: 'end'
    });
  }
  const getBuilding = async data => {
    const resp = await store.buildings.getBuildingAsync.run(data);
    return resp;
  };
  const getCurrentCycle = async data => {
    const resp = await store.allocations.getCurrentCycleAsync.run(data);
    return resp;
  };
  const getPropertiesDashboard = async data => {
    const resp = await store.properties.getPropertiesDashboardAsync.run(data);
    return resp;
  };
  const submitFinalStatements = async () => {
    const resp = await store.fse.submitFinalStatementsAsync.run({
      residencyId
    });
    return resp;
  };
  useEffect(() => {
    Promise.all([getBuilding({
      propertyId
    }).then(async resp => {
      if (!resp) navigate('/');
    }), getCurrentCycle({
      companyId: localStorage.getItem(USER_SETTINGS_KEYS.company)
    }), getPropertiesDashboard({
      portfolioId: localStorage.getItem('livable_portfolio_id')
    })]);
  }, []);
  useEffect(() => {
    if (selectedTab) store.residencies.saveActiveTab(selectedTab);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- sync URL tab to store for refreshFlag / grid logic
  }, [selectedTab]);
  useEffect(() => {
    if (fseModal && residency) {
      store.fse.setFSEBillModalData({
        accountId: '',
        residentName: residency.fullName,
        residencyId: residencyIdPar,
        unitName: residency.unitName
      });
      store.fse.setFSEBillGeneralModalIsOpen(true);
    }
  }, [residency]);
  const getTab = () => {
    switch (selectedTab) {
      case 'statements':
        return /*#__PURE__*/React.createElement(StatementsTable, {
          propertyId: propertyId
        });
      case 'allocations':
        return /*#__PURE__*/React.createElement(AllocationsTab, {
          propertyAddress: store.buildings.getBuilding.buildingAddress,
          propertyId: propertyId
        });
      // case 'charges':
      //   return <ReccuringChargesTable />;
      case 'activity-log':
        return /*#__PURE__*/React.createElement(ActivityLogTable, {
          propertyId: propertyId
        });
      case 'appfolio-batches':
        return /*#__PURE__*/React.createElement(AppfolioBatchesTable, {
          propertyId: propertyId
        });
      // case 'reports':
      //   return <ReportsTab />;
      case 'residencies':
      default:
        return /*#__PURE__*/React.createElement(ResidenciesTab, {
          activeResidency: store.buildings.getBuilding.buildingAddress,
          buildingId: store.buildings.getBuilding.id,
          propertyId: propertyId
        });
    }
  };
  const handleSubmitFinalStatements = () => submitFinalStatements().then(() => {
    toast('success', {
      body: ['Final statement sent']
    });
    store.fse.setFSEBillIsSubmited(true);
  }).finally(() => store.residencies.toggleRefreshFlag(true));
  return /*#__PURE__*/React.createElement("div", {
    className: classes.tenanciesPageContainer
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.buildings.getBuildingAsync.inProgress,
    zIndex: 300
  }), /*#__PURE__*/React.createElement(BreadcrumbsBar, {
    breadcrumbsArray: breadcrumbArray,
    showMembers: true
  })), /*#__PURE__*/React.createElement(Box, {
    className: classes.topSectionWrapper
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(TopActionButtons, {
    allocationCycleId: store.allocations.currentCycle.id,
    showEnrollModal: isEnrollModalOpen
  }), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(DistributionSummary, {
    propertyData: store.properties.propertyById(propertyId)
  }))), /*#__PURE__*/React.createElement(PageTabs, {
    handleSelectedTabChange: handleChange,
    selectedTab: selectedTab,
    tabs: tabs
  }), /*#__PURE__*/React.createElement(Box, {
    className: classes.tabContent
  }, getTab()), isFinalStatementEstimationEnabled && (residencyId || residencyIdPar) && /*#__PURE__*/React.createElement(FSEBillModal, {
    disabled: store.fse.submitFinalStatementsAsync.inProgress,
    disabledTrigger: true,
    isOpen: store.fse.FSEBillGeneralModalIsOpen,
    propertyId: propertyId,
    residentName: residentName,
    residencyId: residencyId || residencyIdPar,
    setFSEBillModalIsOpen: store.fse.setFSEBillGeneralModalIsOpen,
    submitFSE: handleSubmitFinalStatements,
    triggerType: "disabledTrigger",
    unitName: unitName
  }));
});